import { get, isEmpty } from 'lodash'
import { LicenseTier, LicenseTierType, CheckLicenseResultPayload, LicenseInfo } from '@/types/license'

const LICENSE_STORAGE_KEY = 'daisy_license_info'

export const determineLicenseTier = (payload: CheckLicenseResultPayload): LicenseTierType => {
  // 라이센스 키가 없는 경우
  if (payload.allFailed) {
    return LicenseTier.NO_LICENSE
  }

  const { passedFeatures, conditionalResult } = payload

  // OPS (40003) - 모든 기능 사용 가능
  if (passedFeatures.includes(40003)) {
    return LicenseTier.OPS
  }

  // TEAMS (40002)
  if (passedFeatures.includes(40002)) {
    return LicenseTier.TEAMS
  }

  // PRO (40001)
  if (passedFeatures.includes(40001)) {
    const conditionalFeatures = get(conditionalResult, 'passedConditionalFeatures') || []

    if (isEmpty(conditionalFeatures)) {
      // NOTE: 솔루엠은 라이센스 기능이 들어가기 전에 배포되어서 conditionalFeatures가 비어있음. 이경우 PRO_IMG로 처리.
      return LicenseTier.PRO_IMG
    }

    const hasImage = conditionalFeatures.includes(41001)
    const hasTimeSeries = conditionalFeatures.includes(41002)
    const hasTabular = conditionalFeatures.includes(41003)

    // 모든 조합 처리
    if (hasImage && hasTimeSeries && hasTabular) {
      return LicenseTier.PRO_IMG_TS_TAB
    }
    if (hasImage && hasTimeSeries) {
      return LicenseTier.PRO_IMG_TS
    }
    if (hasImage && hasTabular) {
      return LicenseTier.PRO_IMG_TAB
    }
    if (hasTimeSeries && hasTabular) {
      return LicenseTier.PRO_TS_TAB
    }
    if (hasImage) {
      return LicenseTier.PRO_IMG
    }
    if (hasTimeSeries) {
      return LicenseTier.PRO_TS
    }
    if (hasTabular) {
      return LicenseTier.PRO_TAB
    }
  }

  return LicenseTier.NO_LICENSE
}

export const saveLicenseInfo = (payload: CheckLicenseResultPayload): void => {
  const tier = determineLicenseTier(payload)

  const licenseInfo: LicenseInfo = {
    tier,
    passedFeatures: payload.passedFeatures,
    conditionalFeatures: payload.conditionalResult?.passedConditionalFeatures,
  }

  localStorage.setItem(LICENSE_STORAGE_KEY, JSON.stringify(licenseInfo))

  console.log('[License] Saved license info:', licenseInfo) // TODO : remove debug log
}

export const getLicenseInfo = (): LicenseTierType | null => {
  try {
    const data = localStorage.getItem(LICENSE_STORAGE_KEY)
    if (!data) {
      return null
    }
    const parsed = JSON.parse(data) as LicenseInfo
    return parsed.tier
  } catch (error) {
    console.error('[License] Failed to parse license info from localStorage:', error)
    return null
  }
}

export const clearLicenseInfo = (): void => {
  localStorage.removeItem(LICENSE_STORAGE_KEY)
}
